import { useMemo } from 'react';
import { ServicesKeys } from '~/types/Services';
import { useGetApplication } from './wizard';

export type UseAmendmentResult = {
  isAmendment: boolean;
  lockedProductKeys: ServicesKeys[];
  isProductLocked: (key: ServicesKeys) => boolean;
};

export const useAmendment = (): UseAmendmentResult => {
  const applicationQuery = useGetApplication();
  const payload = applicationQuery.data?.payload;

  return useMemo(() => {
    const isAmendment = payload?.applicationType === 'AMENDMENT';
    const lockedProductKeys = isAmendment ? payload?.amendmentList?.lockedProducts ?? [] : [];
    const lockedSet = new Set<ServicesKeys>(lockedProductKeys);

    return {
      isAmendment,
      lockedProductKeys,
      isProductLocked: (key) => lockedSet.has(key),
    };
  }, [payload?.applicationType, payload?.amendmentList]);
};
